
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_xttbq_17988_9"
};
  